import { config } from 'api';
import errorHandler from 'utils/errorHandler';

export const REQUEST_LOGGED_OUT_HOMEPAGE_STATIC_CONTENT = 'REQUEST_LOGGED_OUT_HOMEPAGE_STATIC_CONTENT';
export const RECEIVE_LOGGED_OUT_HOMEPAGE_STATIC_CONTENT = 'RECEIVE_LOGGED_OUT_HOMEPAGE_STATIC_CONTENT';
export const RECEIVE_LOGGED_OUT_HOMEPAGE_STATIC_CONTENT_ERROR = 'RECEIVE_LOGGED_OUT_HOMEPAGE_STATIC_CONTENT_ERROR';

function requestLoggedOutHomePageStaticContent() {
  return {
    type: REQUEST_LOGGED_OUT_HOMEPAGE_STATIC_CONTENT,
  };
}

function receiveLoggedOutHomePageStaticContent(content) {
  return {
    type: RECEIVE_LOGGED_OUT_HOMEPAGE_STATIC_CONTENT,
    content,
  };
}

function receiveLoggedOutHomePageStaticContentError() {
  return {
    type: RECEIVE_LOGGED_OUT_HOMEPAGE_STATIC_CONTENT_ERROR,
  };
}

export function ensureLoggedOutHomePageStaticContent() {
  return (dispatch, getState, { network }) => {
    const loggedOutHpStaticContentState = getState().loggedOutHomePageStatic;
    if (loggedOutHpStaticContentState &&
      (loggedOutHpStaticContentState.isReceived || loggedOutHpStaticContentState.isFetching)
    ) {
      return Promise.resolve(); // already present in store
    }
    dispatch(requestLoggedOutHomePageStaticContent());

    return network.get(`${config.apiBasePath}/homepage/logged-out/static-content`)
      .then(content => dispatch(receiveLoggedOutHomePageStaticContent(content)))
      .catch(err => {
        dispatch(receiveLoggedOutHomePageStaticContentError());
        errorHandler(err);
      });
  };
}
